import * as React from 'react';
import { default as Flight } from '../../../../Flight';
import { useTheme } from '../../../../theme';
import MediaQuery from 'react-responsive';
import { TABLET_MIN_WIDTH } from '../../../../utils';
import { useTranslation } from 'react-i18next';
import { CheckoutOrderFragment, FlightFragment } from '@websky/graphql';
import { useRenderers } from '../../../../renderProps';
import { checkoutSegmentGroupToFlightPropsAdapter } from '../../../../Flight/adapters';

export interface Props {
	flight: FlightFragment;
	confirmed?: boolean;
	canceled?: boolean;
	orderId: string;
	hidePrice?: boolean;

	order?: CheckoutOrderFragment;
}

const SelectedFlight: React.FC<Props> = ({ flight, confirmed, canceled, orderId, hidePrice }) => {
	const theme = useTheme('Checkout').CheckoutStyles;

	const { t } = useTranslation('Checkout');

	const { renderCheckoutSelectedFlight: RenderCheckoutSelectedFlightOverride = Flight } = useRenderers();

	return (
		<div className={theme.selectedFlight__container}>
			<MediaQuery maxWidth={TABLET_MIN_WIDTH}>
				<div className={theme.selectedFlight__header}>
					{t(flight.segmentGroups.length > 1 ? 'Flights' : 'Flight')}
				</div>
			</MediaQuery>

			{flight.segmentGroups.map((group, index) => {
				return (
					<RenderCheckoutSelectedFlightOverride
						key={index}
						hidePrice={hidePrice}
						{...checkoutSegmentGroupToFlightPropsAdapter(
							orderId,
							flight,
							flight.segmentGroups.find(segmentGroup => segmentGroup.groupId === group.groupId),
							confirmed,
							canceled
						)}
					/>
				);
			})}
		</div>
	);
};

export default SelectedFlight;
